import { type MeetingFragment } from "@/graphql/generated-types";
import type { MeetingParticipantData } from "@/types";

const toParticipantsData = (data: MeetingFragment): MeetingParticipantData => {
  const participants = data.participants || [];

  return {
    employeesSignedUp: participants
      .filter((item) => item.__typename === "Employee")
      .map((item) => item.id)
      .toSorted(),

    residentsSignedUp: participants
      .filter((item) => item.__typename === "Resident")
      .map((item) => item.id)
      .toSorted(),
  };
};

export default {
  toParticipantsData,
};
